import React from 'react';
import { TableRow } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Table';
import { buildElementStyling } from '../utils';
const RichTextTableRow = ({ children, value }) => {
    const { className, style } = buildElementStyling({ value, baseClass: 'richTextTableRow' });
    return (React.createElement(TableRow, { className: className, style: style }, children));
};
RichTextTableRow.displayName = 'RichTextTableRow';
export default RichTextTableRow;
//# sourceMappingURL=TableRow.js.map